// extracted by mini-css-extract-plugin
export default {"popoverContent":"styles_popoverContent__Eq2c7"};